var utilsPayloadCheckout = (function(window, document) {

    // Get offset time given timeZone
    function getTimezoneOffset(d, tz) {
        var a = d.toLocaleString("ja", {timeZone: tz}).split(/[/\s:]/);
        a[1]--;
        var t1 = Date.UTC.apply(null, a);
        var t2 = new Date(d).setMilliseconds(0);
        return (t2 - t1) / 60 / 1000;
    };

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    };

    // Convert to ISO time with offset
    function convertToISOFormat(dateF, timeZoneStr) {
        var dateFormated = new Date(dateF);
        var timezoneOffset = getTimezoneOffset(new Date(dateF), timeZoneStr);
        var sign;
        if(timezoneOffset > 0) {
            sign = '-'
        } else {
            timezoneOffset = timezoneOffset*(-1)
            sign = '+'
        }
        var timezoneOffsetHours = timezoneOffset/60

        var dateISO = [
            dateFormated.getFullYear(),
            padTo2Digits(dateFormated.getMonth() + 1),
            padTo2Digits(dateFormated.getDate()),
        ].join('-')
        
        var timeISO =[
        padTo2Digits(dateFormated.getHours()),
        padTo2Digits(dateFormated.getMinutes()),
        padTo2Digits(dateFormated.getSeconds()),
        ].join(':')

        var cstToISO = dateISO+"T"+timeISO+sign+timezoneOffsetHours+":00";

        return cstToISO;
    };

    /* Methods to obtain ISO time values for payload end*/
    // Get ISO format for CST time
    function getCstTime() {
        var date = new Date();

        var dateInCST = date.toLocaleString(
            'en-US', 
            {
                timeZone: 'America/Chicago',
                hour12: false,
            }
        );
        return dateInCST
    };
    /* Methods to obtain ISO time values for payload end*/

    function formatDate(date) {
        var timezone = date.getTimezoneOffset();
        var sign = (timezone > 0) ? '-' : '+';
        
        return (
        [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
        ].join('-') +
        'T' +
        [
            this.padTo2Digits(date.getHours()),
            this.padTo2Digits(date.getMinutes()),
            this.padTo2Digits(date.getSeconds()),
        ].join(':') +
        sign + (timezone/60) + ":00"
        );
    };
    

    return {
        getTimezoneOffset: getTimezoneOffset,
        padTo2Digits: padTo2Digits,
        convertToISOFormat: convertToISOFormat,
        getCstTime: getCstTime,
        formatDate: formatDate,
    };
    
})(window, document);
